import Swup from "swup";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

import { productionsParallax } from "./components/productions-parallax";
import { initHeroSlideshow } from "./components/hero-slideshow";
import { initCollapsible } from "./components/collapsible";
import { initTeamExpand } from "./components/team-expand";
import { initMobileNav } from "./components/mobile-nav";
import { initProductionOverlay } from "./components/production-overlay";
import { initProductionTabs } from "./components/production-tabs";
import { initFabulatoireFilters } from "./components/fabulatoire-filters";
import {
  initFooterIllustration,
  resetFooterIllustration,
} from "./components/footer-illustration";
import { closeMobileNav } from "./components/mobile-nav";
import { initBlurUp } from "./components/blur-up";
import { initProjectTitlePan } from "./components/project-title-pan";
import { initProductionCarousel } from "./components/production-carousel";
import { initAboutCarousel } from "./components/about-carousel";

const syncHomeScrollState = () => {
  const isHome = document.body.classList.contains("site-page-home");
  document.body.classList.toggle("no-scroll", isHome);
};

const syncNavActiveState = () => {
  const links = document.querySelectorAll(".c-site-nav a, .c-nav-overlay a");
  const currentPath = window.location.pathname.replace(/\/$/, "");

  links.forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) {
      return;
    }
    const linkPath = link.pathname.replace(/\/$/, "");
    const isActive = linkPath === currentPath;
    if (isActive) {
      link.setAttribute("aria-current", "page");
  } else {
      link.removeAttribute("aria-current");
    }
  });
};

/**
 * Header language links live outside Swup’s #main, so their hrefs go stale after
 * in-app navigation. Each page renders the correct URLs inside #main; we copy
 * them onto the header links. Kirby generates full URLs (subfolders, staging domains, etc.).
 */
const syncLanguageSwitchHrefs = () => {
  const payload = document.querySelector("#main [data-lang-switch-targets]");
  const raw = payload?.dataset?.langSwitchTargets;
  if (!raw) {
    return;
  }

  let urls;
  try {
    urls = JSON.parse(raw);
  } catch {
    return;
  }

  document
    .querySelectorAll(".c-lang-switch__link[hreflang], .c-nav-overlay__lang-link[hreflang]")
    .forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) {
        return;
      }
      const code = link.getAttribute("hreflang");
      if (!code || typeof urls[code] !== "string") {
        return;
      }
      link.href = urls[code];
    });
};

const initSwup = () => {
    const swup = new Swup({
      containers: ["#main"],
      animateHistoryBrowsing: true,
      animationSelector: "#main",
      linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]):not(.c-lang-switch__link):not(.c-nav-overlay__lang-link), a[href^="/"]:not([data-no-swup]):not(.c-lang-switch__link):not(.c-nav-overlay__lang-link)',
      cache: true,
      skipPopStateHandling: false,
      plugins: [
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "site-page-",
        }),
      ],
    });

    window.swup = swup;

    if (swup.hooks) {
      swup.hooks.on("page:view", () => {
        requestAnimationFrame(() => {
        document.body.classList.remove("is-modal-open");
        closeMobileNav();
        syncHomeScrollState();
        syncNavActiveState();
        syncLanguageSwitchHrefs();
        productionsParallax();
        initCollapsible();
        initTeamExpand();
        initHeroSlideshow();
        initProductionOverlay();
        initProductionTabs();
        initFabulatoireFilters();
        resetFooterIllustration();
        initFooterIllustration();
        initBlurUp();
        initProjectTitlePan();
        initProductionCarousel();
        initAboutCarousel();
      });
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  syncHomeScrollState();
  syncNavActiveState();
  syncLanguageSwitchHrefs();
  productionsParallax();
  initHeroSlideshow();
  initCollapsible();
  initTeamExpand();
  initMobileNav();
  initProductionOverlay();
  initProductionTabs();
  initFabulatoireFilters();
  initFooterIllustration();
  initBlurUp();
  initProjectTitlePan();
  initProductionCarousel();
  initAboutCarousel();
  initSwup();
});
